import React, { useState } from 'react';
import { Table, Button, Row, Col } from 'react-bootstrap';
import { InergenModal } from './InergenModal';
import { ProductListModal } from './ProductListModal';
import { useSimaTechContext } from './Context';
import { FetchData } from './DataAccess';

const Caption = (tableData) => {
  const { dateSpanFormat, displayOverview, date } = tableData
  //if (displayOverview === 'ProductList') {
  //}
  //else {
  if (displayOverview === 'WeeklyOverview') {
    return <h4>{dateSpanFormat}</h4>
  }
  else if (displayOverview === 'WorkDay') {
    return <h4>{date}</h4>
  }
  else {
    return null
  }

}

const Headers = (props) => {
  return props.map((column) => (
    <th key={column.id}>{column.label}</th>
  ))
}

const TableRow = ({ children, tableData, handleWorkDayClick, handleTaskLineInergen, item }) => {
  const { columns, displayOverview } = tableData
  const [expanded, setExpanded] = useState(false)

  const toggleExpander = (e) => {
    if (!expanded) {
      setExpanded(true)
    } else {
      setExpanded(false)
    }
  }
  const showInergen = (taskLine) => {
    handleTaskLineInergen(taskLine)
  }

  //if (displayOverview === 'ProductList') {
  //}
  //else   
  if (displayOverview === 'WeeklyOverview') {
    return (
      <tr
        key={"workday" + item.date}
        onClick={item.assignmentCount > 0 ? () => handleWorkDayClick(item.date) : undefined}
        className={item.assignmentCount === 0 ? 'tableRowNoAssigments' : item.assignmentCount === item.activeAssignmentCount ? 'tableRowActiveAssigments' : null}
        style={{ cursor: item.assignmentCount > 0 ? 'pointer' : 'default' }}
      >
        {children}
      </tr>
    );
  }
  else if (displayOverview === 'WorkDay') {
    const assignment = item;
    //const assignment = {
    //  type: "contract",
    //  adviced: "Ja",
    //  assignmentId: "8615",
    //  billTo: {
    //    address: "asdfghj",
    //    city: "sdfgh",
    //    name: "asdfghj",
    //    postCode: "asdfgh",
    //    priceGroup: "sadfghj"
    //  },
    //  customerAddress: "Lautrupparken, 2750 Ballerup",
    //  expirationDate: "sadasd",
    //  externalComment: "asdsad",
    //  frAgreement: "asdsad",
    //  frPlasters: "asdasdsagsagsagsag",
    //  isActive: false,
    //  isO9000: "asgdfghjgfds",
    //  manualProcessing: "sdfghjjhgfds",
    //  manualProcessingNotes: "sdfghjkjhg",
    //  noOfLines: "sdfghjkjhg",
    //  resourceCode: "sdafghj",
    //  ressourceComment: "sdfghjk",
    //  securityPackage: "sdfghj",
    //  sellTo: {
    //    address: "sadfghjk",
    //    address2: "sadfghjk",
    //    city: "sdfghjkljhgfds",
    //    contactName1: "asdfghjk",
    //    contactName2: "sdfghj",
    //    ean: "kjhgfd",
    //    email: "sadfghj",
    //    mobileNo: "lkjhgfd",
    //    name: "sdfghjk",
    //    name2: "zsdfghjkjkhgfds",
    //    phoneNo: "aksjfos",
    //    postCode: "asdfghkjlæø"
    //  },
    //  subscriptionNo: "asdfghjiolpæ",
    //  taskInvLines: [{

    //  }],
    //  taskLines: [{
    //    linePosNo: 'asd',
    //    location: 'asdsad',
    //    inergen: 'asdlljlkf',
    //    modelNo: 'asdlljlkf',
    //    replacement: 'asdlljlkf',
    //    itemNo: 'asdlljlkf',
    //    nextReplacement: 'asdlljlkf',
    //    serviced: 'asdlljlkf',
    //    itemSold: 'asdlljlkf',
    //    pressureTested: 'asdlljlkf',
    //    specCommentCode: 'asdlljlkf'
    //  }],
    //  workTime: "09:14 - 09:29"
    //}
    const isContract = assignment.type ? assignment.type.toLowerCase() === "contract" : false;
    return [
      <tr key={"assignment" + item.assignmentId} onClick={(e) => toggleExpander(e)} className={!item.isActive ? 'tableRowNoAssigments' : 'tableRowActiveAssigments'} style={{ cursor: 'pointer' }}>
        {children}
      </tr>,
      expanded && (
        <tr className={!item.isActive ? 'tableRowNoAssigments expandable' : 'tableRowActiveAssigments expandable'} key={"tr-expander" + item.assignmentId}>
          <td colSpan={columns.length}>
            <Row className="mx-1">
              <Col sm={12}>
                <Row className="border-bottom">
                  <Col sm={6}>
                    <Col>
                      <span className='headline'>Leveringsadresse</span>
                    </Col>
                    {assignment.sellTo.name ? <Col>{assignment.sellTo.name}</Col> : null}
                    {assignment.sellTo.name2 ? <Col>{assignment.sellTo.name2}</Col> : null}
                    {assignment.sellTo.address ? <Col>{assignment.sellTo.address}</Col> : null}
                    {assignment.sellTo.address2 ? <Col>{assignment.sellTo.address2}</Col> : null}
                    {assignment.sellTo.postCode ? <Col>{assignment.sellTo.postCode}</Col> : null}
                    {assignment.sellTo.city ? <Col>{assignment.sellTo.city}</Col> : null}
                    {assignment.sellTo.ean ? <Col>EAN:{assignment.sellTo.ean}</Col> : null}
                    <Col>
                      <span className='headline'>Fakturer til</span>
                    </Col>
                    {assignment.billTo.name ? <Col>{assignment.billTo.name}</Col> : null}
                    {assignment.billTo.address ? <Col>{assignment.billTo.address}</Col> : null}
                    {assignment.billTo.postCode ? <Col>{assignment.billTo.postCode}</Col> : null}
                    {assignment.billTo.city ? <Col>{assignment.billTo.city}</Col> : null}
                    <Col>
                      <span className='headline'>Ekstern kommentar</span>
                    </Col>
                    {assignment.externalComment ? <Col>{assignment.externalComment}</Col> : null}
                  </Col>
                  <Col sm={6}>
                    {isContract ? <>
                      {assignment.sellTo.contactName1 ? <Col>Att:{assignment.sellTo.contactName1}</Col> : null}
                      {assignment.sellTo.contactName2 ? <Col>Att:{assignment.sellTo.contactName2}</Col> : null}
                      {assignment.sellTo.phoneNo ? <Col>Telefon:{assignment.sellTo.phoneNo}</Col> : null}
                      {assignment.sellTo.mobileNo ? <Col>Mobil:{assignment.sellTo.mobileNo}</Col> : null}
                    </> : null}

                    {assignment.sellTo.email ? <Col>E-mail:{assignment.sellTo.email}</Col> : null}

                    {isContract ? <>
                      {assignment.fRAgreement ? <Col>Abn. Type B:{assignment.fRAgreement}</Col> : null}
                      {assignment.subscriptionNo ? <Col>Abn. Nr.:{assignment.subscriptionNo}</Col> : null}
                      {assignment.fRPlasters ? <Col>Abn. Type F:{assignment.fRPlasters}</Col> : null}
                      {assignment.securityPackage ? <Col>SP.:{assignment.securityPackage}</Col> : null}
                    </> : null}

                    {assignment.billTo.priceGroup ? <Col>{assignment.billTo.priceGroup}</Col> : null}
                    {assignment.iSO9000 ? <Col>Certificeret:{assignment.iSO9000}</Col> : null}
                    {assignment.resourceCode ? <Col>Montør:{assignment.resourceCode}</Col> : null}
                    {isContract ? <>
                      {assignment.expirationDate ? <Col>Ønsket lev. dato:{assignment.expirationDate}</Col> : null}
                    </> : null}
                    {assignment.noOfLines ? <Col>Enheder:{assignment.noOfLines}</Col> : null}

                    <Col>
                      <span className='headline'>Montørbemærkninger</span>
                    </Col>
                    {assignment.ressourceComment ? <Col>{assignment.ressourceComment}</Col> : null}
                  </Col>
                </Row>
              </Col>
              <Col sm={12}>
                <Row className="border-bottom">
                  {assignment.manualProcessing ? <Col sm={12}>Manuel behandling:{assignment.manualProcessing}</Col> : null}
                  {assignment.manualProcessingNotes ? <Col sm={12}>Manuel kommentar:{assignment.manualProcessingNotes}</Col> : null}
                </Row>
              </Col>
              <Col sm={12}>
                {
                  isContract && assignment.taskLines !== null && assignment.taskLines.length > 0 ?
                    <Row className="border-bottom">
                      <Col sm={12}>
                        <span className='headline'>Servicekontrakt</span>
                      </Col>
                      <Table responsive size="sm">
                        <thead>
                          <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>Model</th>
                            <th>Årgang</th>
                            <th>Type</th>
                            <th>Næste trykprøve</th>
                            <th>Efterset</th>
                            <th>Trykprøvet / Ombyttet</th>
                            <th>Nysalg</th>
                            <th>Særlige bemærkninger</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            assignment.taskLines.map((taskLine) => {
                              return (
                                <tr key={"taskLine"+taskLine.linePosNo}>
                                  {taskLine.linePosNo ? <td>{taskLine.linePosNo}</td> : <td></td>}
                                  {taskLine.location ? <td>{taskLine.location}</td> : <td></td>}
                                  {taskLine.inergen ? <td><img src='images/Inergen.png' onClick={() => showInergen(taskLine)} alt="assignment-inergen" style={{ cursor: 'pointer' }} /></td> : <td></td>}
                                  {taskLine.modelNo ? <td>{taskLine.modelNo}</td> : <td></td>}
                                  {taskLine.replacement ? <td>{taskLine.replacement}</td> : <td></td>}
                                  {taskLine.itemNo ? <td>{taskLine.itemNo}</td> : <td></td>}
                                  {taskLine.nextReplacement ? <td>{taskLine.nextReplacement}</td> : <td></td>}
                                  {taskLine.serviced ? <td>{taskLine.serviced}</td> : <td></td>}
                                  {taskLine.itemSold ? <td>{taskLine.itemSold}</td> : <td></td>}
                                  {taskLine.pressureTested ? <td>{taskLine.pressureTested}</td> : <td></td>}
                                  {taskLine.specCommentCode ? <td>{taskLine.specCommentCode}</td> : <td></td>}
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </Table>
                    </Row>
                    : null
                }

                {
                  assignment.taskInvLines != null && assignment.taskInvLines.length > 0 ?
                    <Row className="border-bottom">
                      <Col sm={12}>
                        <span className='headline'>{isContract ? <>Leveret materiel og reservedele</> : <>Salgsordre</>}</span>
                      </Col>
                      <Table responsive size="sm">
                        <thead>
                          <tr>
                            <th>VareNr</th>
                            <th>Betegnelse</th>
                            <th>Antal</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            assignment.taskInvLines.map((taskInvLine) => {
                              return (
                                <tr key={"taskInvLine" + taskInvLine.description}>
                                  {taskInvLine.itemNo ? <td>{taskInvLine.itemNo}</td> : <td></td>}
                                  {taskInvLine.description ? <td>{taskInvLine.description}</td> : <td></td>}
                                  {taskInvLine.quantity ? <td>{taskInvLine.quantity}</td> : <td></td>}
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </Table>
                    </Row>
                    : null
                }
              </Col>
            </Row>
          </td>
        </tr>
      )
    ];
  }
  else {
    return null
  }
}

const Body = (
  tableData,
  handleWorkDayClick,
  handleTaskLineInergen
) => {
  const { data, columns } = tableData
  return data.map((item, index) => {
    return (
      <TableRow key={index} dataIndex={index} tableData={tableData} item={item} handleWorkDayClick={handleWorkDayClick} handleTaskLineInergen={handleTaskLineInergen}>
        {
          columns.map((header, hIndex) => {
            const value = item[header.id]
            if (typeof value === "object" && value !== null) {
              return <td key={hIndex}>{JSON.stringify(value)}</td>
            }
            else if (Array.isArray(value)) {
              return value.map((valueItem) => {
                const itemValue = value[valueItem];
                return <td key={valueItem.id}>{itemValue}</td>
              })
            }
            else
              return <td key={header.id}>{value}</td>
          })
        }
      </TableRow>
    )
  })
}

const VehicleAssignmentTable = (props) => {
  const {
    tableData,
    handleNavigateNextPage,
    handleNavigatePreviousPage,
    onWorkDayClick,
    currentWeekNumber,
    handleDisplayOverview
  } = props
  const { state } = useSimaTechContext();
  const { vehicleId } = state;
  const { data, date, columns, displayOverview } = tableData
  const [taskLineInergen, setTaskLineInergen] = useState(null)
  const [productList, setProductList] = useState(null)

  const handleProductList = (date1, date2) => {
    if (date1 && date2) {                                  
      const getProductListData = 'VehicleId=' + vehicleId + '&Date1=' + date1 + '&Date2=' + date2;
      FetchData('GetProductList', 'POST', getProductListData).then((result) => {
        if (result.errorMessage === null) {
          setProductList({ data: result.productList, date1: date1, date2: date2 })
        } else {
          alert(result.errorMessage);
        }
      },
        (error) => {
          alert('Kunne ikke finde serveren. Prøv igen senere eller kontakt administratoren.');
        }
      );
    }
  }
  const handleTaskLineInergen = (taskLine) => {
    if (taskLine) {
      setTaskLineInergen(taskLine);
    }
  }
  const handleWorkDayClick = (date) => {
    if (date) {
      onWorkDayClick(date)
    }
  }

  return (
    <>
      {
        data === null || data.length === 0 ?
          <Row>
            <Col>
              <h4>Ingen data blev fundet</h4>
            </Col>
          </Row>
          :
          <>
            <Table responsive bordered hover>
              <thead>
                <tr>{Headers(columns)}</tr>
              </thead>
              <tbody>
                {Body(
                  tableData,
                  handleWorkDayClick,
                  handleTaskLineInergen
                )}
              </tbody>
            </Table>

            {Caption(tableData)}

            {
              displayOverview === 'WeeklyOverview' ?
                <Row>
                  <Col sm={{ span: 3, offset: 3 }} className="text-center"><Button variant="primary" onClick={() => handleNavigatePreviousPage()} disabled={currentWeekNumber === 0 ? true : false}><i className="fa fa-angle-left" aria-hidden="true"></i> Forrige uge</Button></Col>
                  <Col sm={3} className="text-center"><Button variant="primary" onClick={() => handleNavigateNextPage()}>Næste uge <i className="fa fa-angle-right" aria-hidden="true"></i></Button></Col>
                  <Col sm={3} className="text-center"><Button variant="primary" onClick={() => handleProductList(data[0].date, data[data.length - 1].date)}>Vis varebehov</Button></Col>
                </Row>
                :
                displayOverview === 'WorkDay' ?
                  <Row>
                    <Col sm={{ span: 6, offset: 3 }} className="text-center"><Button variant="primary" onClick={() => handleDisplayOverview('WeeklyOverview')}><i className="fa fa-angle-left" aria-hidden="true"></i> Tilbage til uge-oversigt</Button></Col>
                    <Col sm={3} className="text-center"><Button variant="primary" onClick={() => handleProductList(date, date)}>Vis varebehov</Button></Col>
                  </Row>
                  : null
              //displayOverview === 'ProductList' ?
              //  null
              //  : null
            }
          </>
      }
      <InergenModal taskLineInergen={taskLineInergen} handleTaskLineInergen={handleTaskLineInergen} />

      <ProductListModal productList={productList} handleProductList={handleProductList} />
    </>
  );
}
export default VehicleAssignmentTable